const {h, render, Component} = require('preact');

class Title extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div class="refund-request-form title">
        {I18n.translate('js.modules.support.refund_request')}
      </div>
    )
  }
}

module.exports = Title